import Home from '../views/home' //首页
import My from '../views/my' //个人中心
import BindAcount from '../views/bindAcount' //账号绑定
import Archives from '../views/archives' //完善健康档案
import PatientInfo from '../views/patientInfo/info' //就诊人信息
import PatientInfoList from '../views/patientInfo/list' //就诊人列表
import SystemActivate from '../views/system/activate' //激活卡
import SystemHealth from '../views/system/health' //中医体检健康卡
import SystemPhysical from '../views/system/Physical'//中医健康体检活动
import Real from '../views/real' //实名认证
import Protocol  from '../views/protocol' //协议
import MedicalDetail from '../views/medical/detail' //测评详情
import MedicalIndex from '../views/medical/index' //体检首页
import MedicalSelect from '../views/medical/select' //第几题
import MedicalStart from '../views/medical/start' //开始测评
import MedicalResultList from '../views/medical/resultList' //测评结果列表
import vouchers from '../views/system/voucher.vue' //我的卡卷
import coupons  from  '../views/system/coupon.vue' //卡卷详情
import stytemLogin from '../views/system/login.vue'
import activeCenter from '../views/system/activity.vue'
import activeCard from '../views/system/activate.vue'
import healthCard from '../views/system/healthCard.vue'
import xiyi from '../views/system/xiyi.vue'
import xiyiDetail from '../views/system/xiyiDetail.vue'
import videoDoctor from '../views/videoDoctor/videoDoctor.vue'
import login from '../views/login.vue'
import register from '../views/register.vue'
import registerNext from '../views/registerNext.vue'

let routes = [
  {
    path: '/home',
    component: Home,
    name: 'Home',
    meta: {
      title: "企业健康管理"
    }
  },
  {
    path: '/xiyi',
    component: xiyi,
    name: 'xiyi',
    meta: {
      title: "我的西医健康档案"
    }
  },  
  {
    path: '/xiyiDetail',
    component: xiyiDetail,
    name: 'xiyiDetail',
    meta: {
      title: "健康详情"
    }
  },  
  {
    path: '/my',
    component: My,
    name: 'My',
    meta: {
      title: "个人中心"
    }
  },
  {
    path: '/login',
    component: login,
    name: 'login',
    meta: {
      title: "用户登录"
    }
  },
  {
    path: '/register',
    component: register,
    name: 'register',
    meta: {
      title: "用户注册"
    }
  },
  {
    path: '/registerNext',
    component: registerNext,
    name: 'registerNext',
    meta: {
      title: "用户注册"
    }
  },
  {
    path: '/bindAcount',
    component: BindAcount,
    name: 'BindAcount',
    meta: {
      title: "账号绑定"
    }
  },
  {
    path: '/archives',
    component: Archives,
    name: 'Archives',
    meta: {
      title: "完善健康档案"
    }
  },
  {
    path: '/patientInfo/info',
    component: PatientInfo,
    name: 'PatientInfo',
    meta: {
      title: "就诊人"
    },
  },
  {
    path: '/real',
    component: Real,
    name: 'Real',
    meta: {
      title: "系统注册"
    },
  },
  {
    path: '/protocol',
    component: Protocol ,
    name: 'protocol',
    meta: {
      title: "协议"
    },
  },
  {
    path: '/patientInfo/list',
    component: PatientInfoList,
    name: 'PatientInfoList',
    meta: {
      title: "就诊人"
    }
  },
  {
    path: '/system/activate',
    component: SystemActivate,
    name: 'systemActivate',
    meta: {
      title: "激活卡"
    }
  },
  {
    path: '/system/health',
    component: SystemHealth,
    name: 'systemHealth',
    meta: {
      title: "中医体检健康卡"
    }
  },
  {
    path: '/system/physical',
    component: SystemPhysical,
    name: 'SystemPhysical',
    meta: {
      title: "中医健康体检活动"
    }
  },
  {
    path: '/medical/detail',
    component: MedicalDetail,
    name: 'MedicalDetail',
    meta: {
      title: "中医体质测评"
    }
  },
  {
    path: '/medical/index',
    component: MedicalIndex,
    name: 'MedicalIndex',
    meta: {
      title: "中医体质测评"
    }
  },
  {
    path: '/medical/select',
    component: MedicalSelect,
    name: 'MedicalSelect',
    meta: {
      title: "中医体质测评"
    }
  },
  {
    path: '/medical/start',
    component: MedicalStart,
    name: 'MedicalStart',
    meta: {
      title: "中医体质测评"
    }
  },
  {
    path: '/medical/resultList',
    component: MedicalResultList,
    name: 'MedicalResultList',
    meta: {
      title: "中医体质测评"
    }
    
  },
  {
    path:'/system/voucher',
    component:vouchers,
    name:'voucher',
    meta: {
      title: "我的卡卷"
    }
  },
  {
    path:'/system/coupon',
    component:coupons,
    name:'coupon',
    meta: {
      title: "卡卷详情"
    }
  },
  {
    path:'/system/login',
    component:stytemLogin,
    name:'stytemLogin',
    meta: {
      title: "系统登录"
    }
  }
  ,{
    path:'/system/activeCenter',
    name:'activeCenter',
    component:activeCenter,
    meta:{
      title:"activeCenter"
    }
  },{
    path:'/system/activate',
    name:'systemactivate',
    component:activeCard,
    meta:{
      title:"激活卡卷"
    }
  },
 {
   path:'/system/healthCard',
   name:"healthCard",
   component:healthCard   
 },
 {
	 path:'/videoDoctor',
	 name:"videoDoctor",
	 component:videoDoctor   	 
 }
];
export default routes;